import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from '../util/isType';

/**
 * @ignore
 * */
class TD extends React.Component {
    static defaultProps = {};

    static propTypes = {
        content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.array,
            PropTypes.bool,
            PropTypes.object,
        ]),
        render: PropTypes.func,
    };

    levelRender = (level) => {
        if (!level) return '';
        const result = [];
        for(let i = 0; i < level; i ++) {
            result.push(<div style={{
                "width": "50px",
                "height": "2px",
                "float": "left"
            }}></div>);
        }
        return result;
    }

    render() {
        const { content, render, level, ...other } = this.props;
        return <td {...other}>
            { this.levelRender(level) }
            {isFunction(render) ? render(content) : content}
        </td>;
    }
}

export default TD;



// WEBPACK FOOTER //
// ./src/table/TableCell.jsx